import get from 'lodash/get';
import dateFormat from 'dateformat';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isNumber from 'lodash/isNumber';
import forOwn from 'lodash/forOwn';

export function msToS(ms) {
    return Math.round(ms / 1000);
}

export function msToM(ms) {
    return Math.round((ms / 60) / 1000);
}

export function sToMs(s) {
    return s * 1000;
}

export function mToMs(m) {
    return m * 60 * 1000;
}

export function hToMs(h) {
    return h * 60 * 60 * 1000;
}

export function dToMs(d) {
    return d * 24 * 60 * 60 * 1000;
}

export function dateAdd(date, interval, units) {
    var ret = new Date(date); //don't change original date
    switch(interval.toLowerCase()) {
        case 'year'   :  ret.setFullYear(ret.getFullYear() + units);  break;
        case 'quarter':  ret.setMonth(ret.getMonth() + 3*units);  break;
        case 'month'  :  ret.setMonth(ret.getMonth() + units);  break;
        case 'week'   :  ret.setDate(ret.getDate() + 7*units);  break;
        case 'day'    :  ret.setDate(ret.getDate() + units);  break;
        case 'hour'   :  ret.setTime(ret.getTime() + units*3600000);  break;
        case 'minute' :  ret.setTime(ret.getTime() + units*60000);  break;
        case 'second' :  ret.setTime(ret.getTime() + units*1000);  break;
        default       :  ret = undefined;  break;
    }
    return ret;
}

export function format(date = new Date(), format = 'yyyy-mm-dd\'T\'HH:MM') {
    date = new Date(date);
    return dateFormat(date, format);
}

export function formatDate(date = new Date()) {
    date = new Date(date);
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
}

export function formatIsoDate(date = new Date()) {
    date = new Date(date);
    return dateFormat(date, 'yyyy-mm-dd');
}

export function formatIsoDateTime(date = new Date()) {
    date = new Date(date);

    return dateFormat(date, 'yyyy-mm-dd')+'T'+dateFormat(date, 'HH:MM');
}

export function formatTimeVariant(variant, formatFunc = formatDate) {
    var formattedProps = ['from', 'to'],
        formattedArrays = ['times', 'dates'];


    if(isArray(variant)) {
        return variant.map((arrValue) => {
            return formatTimeVariant(arrValue, formatFunc);
        });
    }

    if(isNumber(variant)) {
        return formatFunc(variant, formatFunc);
    }

    if(isObject(variant)) {
        var retObj = {...variant};

        forOwn(variant, (value, key) => {
            if(formattedProps.indexOf(key) > -1) {
                retObj[key] = formatFunc(value);
            }

            if(formattedArrays.indexOf(key) > -1) {
                retObj[key] = formatFunc(value);
            }
        });

        return retObj;
    }

    return variant;
}

export function formatSysDate(date = new Date()) {
    date = new Date(date);
    return date.getFullYear()+'-'+(date.getMonth() + 1)+'-'+date.getDate();
}


export function getTimeRangeTitle(from, to, format, dateFormatFunc = dateFormat) {
    format = format ? format : to;
    from = get(from, 'from', from);
    to = get(from, 'to', to);

    var fromFormatted = from ? dateFormatFunc(from, format) : '?',
        toFormatted = to ? dateFormatFunc(to, format) : '?';

    return `${fromFormatted} - ${toFormatted}`;
}

export function getDayTimeRangeTitle(from, to, dateFormatStr, timeFormatStr, dateFormatFunc = dateFormat) {

    var dateFormatted = from ? dateFormatFunc(from, dateFormatStr) : '?',
        fromFormatted = to ? dateFormatFunc(from, timeFormatStr) : '?',
        toFormatted = dateFormatFunc(to, timeFormatStr);

    return `${dateFormatted}  ${fromFormatted} - ${toFormatted}`;
}

export function extractTimeInfo(dateObj = new Date()) {
    dateObj = new Date(dateObj);

    return {
        month: dateObj.getMonth() + 1,
        day: dateObj.getDate(),
        year: dateObj.getFullYear(),
        hours: dateObj.getHours(),
        minutes: dateObj.getMinutes()
    }
}

export function diffInDays(date1, date2) {
    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return diffDays;
}

export const deDateData = {
    dateTimeFormat: 'dd.mm.yyyy HH:MM',
        dateFormat: 'dd.mm.yyyy',
        timeFormat: 'HH:MM',

        weekdaysShort: ["So",'Mo','Di','Mi','Do','Fr','Sa'],
        weekdaysLetter: ["So",'Mo','Di','Mi','Do','Fr','Sa'],
        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        monthsShort: ['Jan','Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        weekdays: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag'
    ],
};

export const getLocalizedFormatDate = (locale) => {
    var localizedFormatDate = require('dateformat');

    localizedFormatDate.i18n = {
        dayNames: [
            ...locale.weekdaysShort,
            ...locale.weekdays
        ],

        monthNames: [
            ...locale.monthsShort,
            ...locale.months
        ],

        timeNames: [],
    };

    return localizedFormatDate;
}

export const deDateFormat = (...props) => {
    var localizedFormatDate = getLocalizedFormatDate(deDateData);
    return localizedFormatDate(...props);
};

export function deFormatDate(date) {
    var dateFormatStr = deDateData.dateFormat;
    return dateFormat(date, dateFormatStr);
}

export function deFormatTime(time) {
    var timeFormatStr = deDateData.timeFormat;
    return dateFormat(time, timeFormatStr);
}

export function deFormatDateTime(time) {
    var timeFormatStr = deDateData.dateTimeFormat;
    return dateFormat(time, timeFormatStr);
}


export function deParseMonthAndYear(str) {
    var dateParts = str.split(' ');

    if(dateParts.length < 2) { return null; }

    return new Date(dateParts[1], deDateData.months.indexOf(dateParts[0]))
}

export function deParseMonthAndYearOrFail(str) {
    var parsed = deParseMonthAndYear(str);

    if(!parsed) {
        throw new Error('Failed to parse '+str+'.');
    }

    return parsed;
}

export function compareYearAndMonth(a, b) {
    var aInfo = extractTimeInfo(a),
        bInfo = extractTimeInfo(b);

    return aInfo.year === bInfo.year && aInfo.month === bInfo.month;
}

export function parseGermanDate(dateString) {
    let match = dateString.match(/(\d*)\.(\d*)\.(\d*)( (\d*):(\d*))?/);
    if(!match) { return null; }

    let d = ['', 1, 0, null, '', 0, 0];
    let [l, day, month, year, timeStr, hours, minutes] = match.map((val, i) => {
        if(val === '' || typeof val === 'undefined') { return d[i]; }
        return val;
    });

    if(year < 1000) {
        year = null;
    }

    let date = new Date(year, month-1, day, hours, minutes);

    // console.log('XX formatted', deFormatDateTime(date));

    return date;
}

export function performanceTime(date = new Date()) {
    date = new Date(date);
    return date.getHours() + ':' + date.getMinutes()+ ':'+date.getSeconds()+'.'+date.getMilliseconds();
}